<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="admin-container">
  <mat-tab-group class="admin-tabs" animationDuration="0ms">
    <mat-tab id="app-manage-collections">
      <ng-template mat-tab-label>
        <label class="labelHeading" data-test-id="admin-nav-collections" matTooltip="Manage collections through the admin panel" >Collections</label>
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content-container">
          <h1 class="margin-left-12">Collections Management</h1>
          <app-manage-collections />
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <label class="labelHeading" data-test-id="admin-nav-users" matTooltip="Manage users through the admin panel" >Users</label>
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content-container">
          <h1 class="margin-left-12">User Management</h1>
          <app-manage-users />
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="enablePersonasManagement">
      <ng-template mat-tab-label>
        <label class="labelHeading" data-test-id="admin-nav-personas" matTooltip="Manage personas through the admin panel" >Personas</label>
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content-container">
          <h1 class="margin-left-12">Personas Management</h1>
          <app-manage-personas />
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab *ngIf="enableSystemPrompts">
      <ng-template mat-tab-label>
        <label class="labelHeading" data-test-id="admin-nav-system-prompts" matTooltip="Manage system prompts through the admin panel" >System Prompts</label>
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content-container">
          <h1 class="margin-left-12">System Prompts Management</h1>
          <app-manage-system-prompts />
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
